<template>

  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <v-text-field
          :style="adjustStyle"
          v-bind="computedProps"
          v-on="computedListeners"/>
      </span>
    </template>
    <span>入力した値で一覧を絞り込む事ができます。</span>
  </v-tooltip>

</template>
<script>
import { VTextField } from 'vuetify/lib'

/**
 * @file DDv2用絞り込みテキスト
 * @namespace components
 */

/**
 * @vue-prop {Number} [length=999] - 入力可能桁数
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-narrow-down-text-box
    v-model="searchText"/>
 */
export default {
  name: 'DdNarrowDownTextBox',
  extends: VTextField,
  props: {
    /**
     * 入力可能桁数
     */
    length: Number,
    /**
     * スタイル指定
     */
    adjustStyle: {
      type: String,
      default: 'padding-top:16px'
    }
  },
  data: () => ({
  }),
  created () {
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        maxlength: this.length,
        type: 'text',
        label: 'ここにキーワードを入力すると一覧を絞込できます',
        hideDetails: true,
        dense: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        focus: e => this.onFocus(e)
      }
    }
  },
  methods: {
    onFocus: function (e) {
      const elem = this.$el.querySelector('input')
      if (elem) { elem.select() }
      this.$emit('focus', e)
    }
  }
}
</script>
<style scoped>
.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
    padding: 8px 0 2px;
}
::v-deep .v-input__slot>.v-text-field__slot>.v-label {
  top: 6px !important;
  font-size: small !important;
  color:#777777 !important;
}
</style>
